import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import LogisticsForm from 'ui-shared/Forms/LogisticsForm'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'

const LogisticsCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create record={{ pricing: STANDARD_PRICING_STARTUP }}>
        <LogisticsForm />
      </Create>
    </SectionWrapper>
  )
}

export default LogisticsCreate
